import React from 'react';

import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { Select } from '@nhl/nhl-breakaway-ui';

import { reportActionCreators } from '~/redux/ducks/playersAndTeams/report';
import { commonMessages } from '~/utility/commonMessages';

import Label from '../../label';
import { SelectContainer } from '../styles';

const PositionSelect = () => {
    const dispatch = useDispatch();
    const intl = useIntl();

    const setPosition = (e, { value }) => {
        dispatch(reportActionCreators.setPosition(value));
        dispatch(reportActionCreators.runReport());
    };

    const selectedPosition = useSelector((state) => state.playersAndTeams.report.current.positionCode);

    const positionCodes = ['F', 'L', 'R', 'C', 'D']; // Forwards, Left Wing, Right Wing, Center, Defense
    const positionOptions = positionCodes.map((code) => ({
        value: code,
        label: intl.formatMessage(commonMessages.positions[code]),
        key: code,
    }));
    const options = [
        {
            value: '',
            label: intl.formatMessage(commonMessages.labels.allSkaters),
            key: 'all',
        },
        ...positionOptions,
    ];

    return (
        <SelectContainer>
            <Label htmlFor="playerPositionCode">{intl.formatMessage(commonMessages.labels.playerPositionCode)}</Label>
            <Select
                onOptionChange={setPosition}
                options={options}
                name="playerPositionCode"
                selectedOption={options.find((obj) => obj.value === selectedPosition)}
                isSearchEnabled
                optionsBoxAriaLabel={intl.formatMessage(commonMessages.labels.playerPositionCode)}
                dropdownButtonAriaLabel=""
            />
        </SelectContainer>
    );
};

export default React.memo(PositionSelect);
